// extracted by mini-css-extract-plugin
export default {"skeleton-loader":"H_7ikau","gradient":"nkWVOHI","skeleton-loader--pill":"idbgVpZ"};